import { Route, Routes } from "react-router-dom";
import { ChampionshipsListAdminView } from "championship/admin/views/ChampionshipsListAdminView";
import { ChampionshipAdminView } from "championship/admin/views/ChampionshipAdminView";
export function ChampionshipAdminRoutes() {
  return (
    <Routes>
      <Route path="" element={<ChampionshipsListAdminView />} />
      <Route path="new" element={<ChampionshipAdminView />} />
      <Route path=":championshipId">
        <Route path="" element={<ChampionshipAdminView />} />
      </Route>
      <Route path=":championshipId/duplicate">
        <Route path="" element={<ChampionshipAdminView />} />
      </Route>
    </Routes>
  );
}
